import { Suspense } from "react";
import { AutocompleteEvaluationCopy } from "@/search/components/evaluation-copy/AutocompleteEvaluationCopy";
import { BookItem } from "@/search/components/types";

type EvaluationCopyBookSearchBarProps = {
  onItemSelect: (book: BookItem) => void;
  className?: string;
};

export function EvaluationCopyBookSearchBar({
  onItemSelect,
  className,
}: EvaluationCopyBookSearchBarProps) {
  return (
    <Suspense>
      <AutocompleteEvaluationCopy
        placeholder={"Søk på tittel, forfatter eller ISBN"}
        detachedMediaQuery="none"
        openOnFocus
        onItemSelect={onItemSelect}
        className={className}
      />
    </Suspense>
  );
}
